<template>
    <div class="app-container">
      <BjDivider>{{ $t('BusinessPurchaseOrder2.code') }}：{{ queryParams.code }}</BjDivider>
      <el-form ref="form" size="mini" :model="queryParams.purchaseOrderReceive" :rules="rules" class="bj-query-form bj-query-form-for-cal-height">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder2.Unit')" prop="shippingMethod">
              <BjSelectLov v-model="queryParams.purchaseOrderReceive.shippingMethod" :option-list="PO_SHIPPINGMETHOD_STATUS_LIST" :placeholder="$t('BusinessPurchaseOrder2.Unit')" @change="onChangeSM" />
            </el-form-item>
          </el-col>
          <el-col v-if="queryParams.purchaseOrderReceive.shippingMethod === 'Container'" :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder2.form.containerId')" prop="containerID">
              <BjInputNumber v-model="containerID" disabled />
            </el-form-item>
          </el-col>
          <el-col v-if="queryParams.purchaseOrderReceive.shippingMethod==='Container'" :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder2.form.isTrue')" prop="isTrue">
              <BjSelectLov v-model="isTrue" :disabled="isShowNewCont" :option-list="STATUS_YES_TRUE" />
            </el-form-item>
          </el-col>
          <el-col v-if="queryParams.purchaseOrderReceive.shippingMethod === 'Container'&&!isTrue" :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder2.form.newContainerId')" prop="newContainerID">
              <BjInput v-model="newContainerID" clearable type="text" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessPurchaseOrder2.form.newContainerId')" />
            </el-form-item>
          </el-col>
          <el-col v-if="queryParams.purchaseOrderReceive.shippingMethod==='Container'" :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder3.Type')" prop="containerType">
              <BjSelectLov v-model="queryParams.purchaseOrderReceive.containerType" :option-list="PO_CONTAINERTYPE_STATUS_LIST" :placeholder="$t('BusinessPurchaseOrder3.Type')" @change="onChangeCT" />
            </el-form-item>
          </el-col>
          <el-col v-if="queryParams.purchaseOrderReceive.shippingMethod==='Container'" :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder3.Size')" prop="containerLength">
              <BjSelectLov v-model="queryParams.purchaseOrderReceive.containerLength" :option-list="PO_CONTAINERLENGTH_STATUS_LIST" :placeholder="$t('BusinessPurchaseOrder3.Size')" @change="onChangeCL" />
            </el-form-item>
          </el-col>
          <el-col v-if="queryParams.purchaseOrderReceive.shippingMethod==='Container' && queryParams.purchaseOrderReceive.containerType!='Pallet'" :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder3.Total')" prop="totalPalletQty">
              <BjInputNumber v-model="queryParams.purchaseOrderReceive.totalPalletQty" :placeholder="$t('BusinessPurchaseOrder3.Total')" />
            </el-form-item>
          </el-col>

          <el-col v-if="queryParams.purchaseOrderReceive.shippingMethod==='Carton'" :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder3.cartonQty')" prop="cartonQty">
              <BjInputNumber v-model="queryParams.purchaseOrderReceive.cartonQty" :placeholder="$t('BusinessPurchaseOrder3.cartonQty')" />
            </el-form-item>
          </el-col>
          <el-col v-if="queryParams.purchaseOrderReceive.shippingMethod==='Carton'" :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder3.Hire')" prop="csgPallet">
              <BjInputNumber v-model="queryParams.purchaseOrderReceive.csgPallet" :placeholder="$t('BusinessPurchaseOrder3.Hire')" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('BusinessPurchaseOrder3.Extra')" prop="labourTime">
              <BjInputNumber v-model="queryParams.purchaseOrderReceive.labourTime" :placeholder="$t('BusinessPurchaseOrder3.Extra')">
                <template slot="append">
                  <el-tooltip class="item" effect="dark" :content="$t('BusinessPurchaseOrder3.Ps1')" placement="bottom">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              </BjInputNumber>
            </el-form-item>
          </el-col>
          <el-col :span="6 * 2">
            <el-form-item :label="$t('BusinessPurchaseOrder3.comments')" prop="comments">
              <BjInput v-model="queryParams.purchaseOrderReceive.comments" type="textarea" show-word-limit autosize :maxlength="999" :placeholder="$t('BusinessPurchaseOrder3.comments')" clearable />
            </el-form-item>
          </el-col>
        </el-row>


        <palletTable v-if="queryParams.purchaseOrderReceive.shippingMethod==='Pallets' || queryParams.purchaseOrderReceive.containerType=='Pallet'" ref="palletTableRef" :tableData="[queryParams.purchaseOrderReceive]"/>
      </el-form>
    

      <el-row style="margin: 20px 0">
        <el-col>
          <el-button v-if="queryParams.purchaseOrderReceive.shippingMethod !='Container'" type="primary" class="main-btn" @click="onPARTIAL">{{ $t('BusinessPurchaseOrder3.PARTIAL') }}</el-button>
          <el-button type="primary" class="main-btn" @click="onFULLY">{{ $t('BusinessPurchaseOrder3.FULLY') }}</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableList" border script max-height="600px">
        <el-table-column prop="shippingMethod" :label="$t('BusinessPurchaseOrder2.Unit')" align="center" />
        <el-table-column prop="creationDate" :label="$t('BusinessPurchaseOrder3.Submit')" align="center" />
        <el-table-column prop="containerLength" :label="$t('BusinessPurchaseOrder3.Size')" align="center" />
        <el-table-column prop="containerType" :label="$t('BusinessPurchaseOrder3.Type')" align="center" />
        <el-table-column prop="totalPalletQty" :label="$t('BusinessPurchaseOrder3.Total')" align="center" />
        <el-table-column prop="csgPallet" :label="$t('BusinessPurchaseOrder3.Hire')" align="center" />
        <el-table-column :label="$t('BusinessPurchaseOrder3.CustomerPalletQty')" align="center">
          <el-table-column prop="standardPallet" :label="$t('BusinessPurchaseOrder3.Standard')" align="center" />
          <el-table-column prop="chepPallet" :label="$t('BusinessPurchaseOrder3.Chep')" align="center" />
          <el-table-column prop="loscomPallet" :label="$t('BusinessPurchaseOrder3.Loscom')" align="center" />
          <el-table-column prop="nonStandardPallet" :label="$t('BusinessPurchaseOrder3.nonStandard')" align="center" />
        </el-table-column>
        <el-table-column prop="cartonQty" :label="$t('BusinessPurchaseOrder3.cartonQty')" align="center" />
        <el-table-column prop="labourTime" :label="$t('BusinessPurchaseOrder3.Extra')" align="center" />
        <el-table-column prop="comments" :label="$t('BusinessPurchaseOrder3.comments')" align="center" />
        <el-table-column prop="createdName" :label="$t('BusinessPurchaseOrder3.Submitter')" align="center" />
      </el-table>
      <!-- <BjPage
        ref="BjPage"
        :query-params="queryParams"
        :col-span="colSpan"
        :get-action="queryApi"
        :serial="serial"
        is-list
        :rightToolbarHide="true"
        :search-btn-hide="true"
        :before-query-search="beforeQuerySearch"
        @showSetting="SortableTable.show"
        @header-dragend="SortableTable.handleHeaderDragend"
        @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
        <template v-slot:tableColumn>
          <el-table-column prop="shippingMethod" :label="$t('BusinessPurchaseOrder2.Unit')" align="center" />
          <el-table-column prop="creationDate" :label="$t('BusinessPurchaseOrder3.Submit')" align="center" />
          <el-table-column prop="containerLength" :label="$t('BusinessPurchaseOrder3.Size')" align="center" />
          <el-table-column prop="containerType" :label="$t('BusinessPurchaseOrder3.Type')" align="center" />
          <el-table-column prop="totalPalletQty" :label="$t('BusinessPurchaseOrder3.Total')" align="center" />
          <el-table-column prop="csgPallet" :label="$t('BusinessPurchaseOrder3.Hire')" align="center" />
          <vxe-colgroup :title="$t('BusinessPurchaseOrder3.CustomerPalletQty')" align="center" fixed="">
            <el-table-column prop="standardPallet" :label="$t('BusinessPurchaseOrder3.Standard')" align="center" />
            <el-table-column prop="chepPallet" :label="$t('BusinessPurchaseOrder3.Chep')" align="center" />
            <el-table-column prop="loscomPallet" :label="$t('BusinessPurchaseOrder3.Loscom')" align="center" />
          </vxe-colgroup>
          <el-table-column prop="cartonQty" :label="$t('BusinessPurchaseOrder3.cartonQty')" align="center" />
          <el-table-column prop="labourTime" :label="$t('BusinessPurchaseOrder3.Extra')" align="center" />
          <el-table-column prop="comments" :label="$t('BusinessPurchaseOrder3.comments')" align="center" />
          <el-table-column prop="createdName" :label="$t('BusinessPurchaseOrder3.Submitter')" align="center" />
        </template>
      </BjPage> -->
    </div>
  </template>
  <script>
  import viewMiXin from '@/utils/view-mixin.js';
  // import pageMiXin from '@/utils/page-mixin.js';
  import { purchaseApi } from '@/api';
  import { PO_SHIPPINGMETHOD_STATUS_LIST, PO_CONTAINERTYPE_STATUS_LIST, PO_CONTAINERLENGTH_STATUS_LIST, STATUS_YES_TRUE } from '@/utils/constants';
  import palletTable from './palletTable';
  
  const getDefaultForm = () => {
    return {
      code: null,
      actualContainerNo: null,
      purchaseOrderReceive: {
          shippingMethod: 'Container',
          containerType: null,
          containerLength: null,
          putWayPalletQty: null,
          totalPalletQty: null,
          standardPallet: null,
          chepPallet: null,
          csgPallet: null,
          shripWrapQty: null,
          labourTime: null,
          comments: null,
          liftOffQty: null,
          cartonQty: null,
          loscomPallet: null,
      },
      status: 0,
    };
  };
  export default {
    name: 'BusinessPurchaseOrderCsgAdminReceive',
    components: { palletTable },
    mixins: [viewMiXin],
    data() {
      return {
        colSpan: 4,
        PO_SHIPPINGMETHOD_STATUS_LIST,
        PO_CONTAINERTYPE_STATUS_LIST,
        PO_CONTAINERLENGTH_STATUS_LIST,
        STATUS_YES_TRUE,
        // getCsgReceivePurchaseOrder
        // queryApi: purchaseApi.getCsgReceivePurchaseOrder,
        // 查询参数
        queryParamsTime_create: null,
        queryParams: getDefaultForm(),
        isTrue: true,
        containerID: this.$route.query.containerId,
        newContainerID: null,
        isShowNewCont: false,
        tableList: []
      };
    },
    computed: {
      // 表单校验
      rules() {
        const validateNewContainer = (rule, value, callback) => {
          this.$nextTick(() => {
            if (!this.newContainerID) {
              callback(new Error(this.$t('inputText')));
            }
            callback();
          });
        };

        return {
            shippingMethod: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            containerType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            containerLength: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            newContainerID: [{ required: true, validator: validateNewContainer, trigger: 'blur' }],
            loscomPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            putWayPalletQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            totalPalletQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            standardPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            chepPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            csgPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            cartonQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            shripWrapQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            nonStandardPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        };
      },
    },
    created() {
        this.queryParams.code = this.$route.query.code;
        if (this.$route.query.shippingMethod == 'Pallet') {
          this.queryParams.purchaseOrderReceive.shippingMethod = 'Pallets';
        } else {
          this.queryParams.purchaseOrderReceive.shippingMethod = this.$route.query.shippingMethod;
        }
    },
    mounted() {
      purchaseApi.getCsgReceivePurchaseOrder(this.queryParams).then(res=>{
        this.tableList = res
      })
    },
    methods: {
        onChangeSM(val) {
            this.queryParams = getDefaultForm();
            this.queryParams.purchaseOrderReceive.shippingMethod = val;
            this.queryParams.code = this.$route.query.code;
            if(val=='Container'&&!this.containerID){
              this.isShowNewCont = true
              this.isTrue = false
            }else{
              this.isShowNewCont = false
            }
        },
        onChangeCT(val) {
            this.queryParams.purchaseOrderReceive.containerType = val;
        },
        onChangeCL(val) {
            this.queryParams.purchaseOrderReceive.containerLength = val;
        },
        // 部分收货按钮
        onPARTIAL() {
            this.beforeReceiveFn(1)
        },
        // 全部收货按钮
        onFULLY() {
          this.beforeReceiveFn(2)
        },
        beforeReceiveFn(val){
          this.queryParams.status = val;
          const receive = this.queryParams.purchaseOrderReceive;
          this.$refs.form.validate(valid => {
              if (valid) {
                // 根据运输方式判断总托盘数是否正确
                console.log(1111, receive)
                if (receive.shippingMethod != 'Carton') {
                  if (receive.shippingMethod === 'Container') {
                    if (this.isTrue) {
                      this.queryParams.actualContainerNo = this.containerID;
                    } else {
                      this.queryParams.actualContainerNo = this.newContainerID;
                    }
                    this.queryParams.purchaseOrderReceive.shripWrapQty = receive.totalPalletQty;
                    this.queryParams.purchaseOrderReceive.putWayPalletQty = receive.totalPalletQty;

                    if(this.queryParams.purchaseOrderReceive.containerType!='Pallet'){
                      receive.csgPallet = receive.totalPalletQty;
                      receive.standardPallet = receive.chepPallet = receive.loscomPallet = 0
                    }else{
                      this.queryParams.purchaseOrderReceive.shripWrapQty = receive.totalPalletQty;
                      this.queryParams.purchaseOrderReceive.putWayPalletQty = receive.totalPalletQty;
                      this.queryParams.purchaseOrderReceive.liftOffQty = Number(receive.standardPallet) + Number(receive.chepPallet) + Number(receive.loscomPallet);
                    }
                    if (receive.totalPalletQty == Number(receive.standardPallet) + Number(receive.chepPallet) + Number(receive.loscomPallet) + Number(receive.csgPallet)) {
                      this.onReceive();
                    } else {
                        this.$message.error(this.$t('BusinessPurchaseOrder3.ps'));
                    }
                  }
                  if (receive.shippingMethod === 'Pallets') {
                    this.queryParams.purchaseOrderReceive.shripWrapQty = receive.totalPalletQty;
                    this.queryParams.purchaseOrderReceive.putWayPalletQty = receive.totalPalletQty;
                    this.queryParams.purchaseOrderReceive.liftOffQty = Number(receive.standardPallet) + Number(receive.chepPallet) + Number(receive.loscomPallet);
                    if (receive.totalPalletQty == Number(receive.standardPallet) + Number(receive.chepPallet) + Number(receive.loscomPallet) + Number(receive.csgPallet)) {
                      this.onReceive();
                    } else {
                        this.$message.error(this.$t('BusinessPurchaseOrder3.ps'));
                    }
                  }
                } else {
                  this.queryParams.purchaseOrderReceive.totalPalletQty = this.queryParams.purchaseOrderReceive.csgPallet
                  this.onReceive();
                }
              }
          });
        },
        // 收货执行方法
        onReceive() {
          purchaseApi.addCsgReceivePurchaseOrder(this.queryParams).then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.queryParams = getDefaultForm();
              this.complete('BusinessPurchaseOrderCsgAdminIndex');
            }
          });
        },
    },
  };
  </script>
  <style lang="scss" scoped>
  ::v-deep .el-dialog__body{
    padding-top: 0!important;
  }
  ::v-deep .el-table .el-form-item.el-form-item--mini{
    margin: 0!important;
  }
  </style>
